/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

/*  Components  */
import { QBRManagedTable } from './QBRManagedTable';
import { QBRPieChart } from './QBRPieChart';
import { QBRReportHeader } from './QBRReportHeader';
import { QBRScoreHistoryAndInsights } from './QBRScoreHistoryAndInsights';

export const QBRFirstUnapprovedAppScore = (props) => {
    const { t } = useTranslation();
    const { reportData, reportWrapper, renderingScheduledReport } = props;
    const reportType = 'UnapprovedAppScore';

    const stages = Object.entries(reportData.data).map(([key, value]) => ({
        name: t(`Common.${key}`),
        value
    }));

    return (
        <>
            <QBRReportHeader {...{ ...props, reportType }} />
            {!reportWrapper && (
                <QBRScoreHistoryAndInsights
                    reportType={reportType}
                    props={{ ...props }}
                />
            )}
            <QBRPieChart
                data={stages}
                renderingScheduledReport={renderingScheduledReport}
                showPopover={false}
                title={t('QBR.applicationApprovalStatus')}
            />
            <hr />
            <QBRManagedTable
                rows={reportData.topUnapproved}
                rowsPerPage={-1}
                title={t('QBR.top10UnApprovedApplicationsByUsage')}
            />
        </>
    );
};
